/* Const,Let & Var will be here */
export const DEVICE_REGISTRATION_SUCCESS = 'DEVICE_REGISTRATION_SUCCESS';

/* Const,Let & Var will be here */

export function deviceRegistrationSuccess(isDeviceAlreadyRegistered, deviceFingerPrintId, deviceId) {
    return {
        type: DEVICE_REGISTRATION_SUCCESS,
        isDeviceAlreadyRegistered: isDeviceAlreadyRegistered,
        deviceFingerPrintId: deviceFingerPrintId,
        deviceId: deviceId
    };
}